const FONTS_FAMILY = {
  // Web Pública (Sin Login): Merriweather para Títulos, Roboto para Cuerpo
  public: {
    title: 'Merriweather, serif',
    body: 'Roboto, sans-serif',
  },
  // Panel de Admin (Post-Login): Inter para UI/Títulos, Roboto para Cuerpo
  admin: {
    title: 'Inter, sans-serif',
    body: 'Roboto, sans-serif',
  },
  regular: {
    body: 'Roboto, sans-serif',
    title: 'Merriweather, serif',
  },
  medium: {
    body: 'Roboto, sans-serif',
    title: 'Merriweather, serif',
  },
  bold: {
    body: 'Roboto, sans-serif',
    title: 'Merriweather, serif',
  },
};

export default FONTS_FAMILY;